import StickyTable from '../../components/StickyTable'
import Sorter, { SortControl } from '../../components/Sorter'
import dayjs from 'dayjs'
import { useQsFilters } from '../../hooks/filters'
import Paginator from '../../components/Paginator'
import { Link } from 'react-router-dom'
import { API_URL } from '../../constants'
import SelectAutoCompleteFilter from '../../components/SelectAutocompleteFilter'
import { Button, Modal, ModalBody } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import classNames from 'classnames'
import { Formik } from 'formik'
import { VField } from '../../components/Fields'
import * as Yup from 'yup'
import { fetchApi } from '@inmagik/react-crud'
import { toast } from 'react-toastify'
import { useAuth } from '../../auth'
import { useOpportunita } from '../../hooks/opportunita'
import ListFilters from '../../components/ListFilters'
import DateRangeField from '../../components/DateRangeField'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? 'cliente',
  data_lte:
    params.get('data_lte') ?? dayjs().add(30, 'day').format('YYYY-MM-DD'),
  data_gte: params.get('data_gte') ?? dayjs().format('YYYY-MM-DD'),
  cliente: params.get('cliente') ?? '',
})

export default function Opportunita() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const { data: opportunita, isLoading } = useOpportunita({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
    data_lte: filters.data_lte,
    data_gte: filters.data_gte,
    cliente: filters.cliente,
  })
  const [openMoreOpportunita, setOpenMoreOpportunita] = useState<number | null>(
    null
  )
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (
        e.target instanceof Element &&
        !e.target.closest(`#opportunita-${openMoreOpportunita}`)
      ) {
        setOpenMoreOpportunita(null)
      }
    }
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [openMoreOpportunita])

  const [stateModalCreaProposta, activateModalCreaProposta] = useModalTrigger()
  const { tokens } = useAuth()

  return (
    <div className="page page-list">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between align-items-center list-header">
          <h1 className="title">Opportunità</h1>
        </div>
        <div className="col-12">
          <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded list-toolbar">
            <ListFilters active={!!filters.data_gte || !!filters.cliente}>
              <div className="d-flex align-items-center">
                <label className="label-m text-body-secondary me-2">
                  Periodo
                </label>
                <DateRangeField
                  start={filters.data_gte}
                  end={filters.data_lte}
                  placeholder="Seleziona periodo"
                  onChange={(start, end) => setFilters({ data_gte: start, data_lte: end, page: 1 })}
                />
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">
                  Cliente
                </label>
                <div style={{ width: '230px' }}>
                  <SelectAutoCompleteFilter
                    className="interventi-cliente-filter"
                    value={uiFilters.cliente ?? ''}
                    placeholder="Cerca cliente"
                    onChange={(value: any) => {
                      if (!value) {
                        return setFilters({
                          cliente: '',
                          page: 1,
                        })
                      } else {
                        setFilters({
                          cliente: value.value,
                          page: 1,
                        })
                      }
                    }}
                    url={`${API_URL}/bilance/cliente/options`}
                    isMulti={false}
                  />
                </div>
              </div>
            </ListFilters>
            <div className="me-2 text-nowrap list-count">
              Stai visualizzando {opportunita?.count ?? 0} di{' '}
              {opportunita?.full_count ?? 0} opportunità
            </div>
          </div>
          <StickyTable isLoading={isLoading}>
            <thead className="position-sticky top-0 bg-white">
              <Sorter
                value={uiFilters.ordering}
                onSortChange={(ordering) =>
                  setFilters({
                    ordering,
                  })
                }
              >
                <tr>
                  <th>
                    <div className="d-flex align-items-center">
                      Cliente
                      <SortControl field="cliente" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Tipo intervento
                      <SortControl field="tipo_scadenza" />
                    </div>
                  </th>

                  <th>
                    <div className="d-flex align-items-center">
                      Sede
                      <SortControl field="sede_indirizzo" />
                    </div>
                  </th>
                  <th>
                    <div className="d-flex align-items-center">
                      Numero bilance
                      <SortControl field="num_bilance" />
                    </div>
                  </th>
                  <th>Azioni</th>
                </tr>
              </Sorter>
            </thead>
            <tbody>
              {opportunita?.results.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center">
                    Nessuna oppurtunità disponibile.
                  </td>
                </tr>
              )}
              {opportunita?.results?.map((opp, i) => (
                <tr
                  key={i}
                  style={{
                    opacity: opp.proposta_exists ? 0.5 : 1,
                  }}
                >
                  <td>
                    <Link className="link-md" to={`/clienti/${opp.pk_cliente}`}>
                      {opp.cliente}
                    </Link>
                  </td>
                  <td>
                    <div
                      className={classNames('p-md mt-2 badge w-max-content', {
                        'bg-rapporto-taratura-light':
                          opp.tipo_scadenza === 'Taratura',
                        'bg-intervento-periodico-light':
                          opp.tipo_scadenza === 'Periodica',
                        'text-rapporto-taratura':
                          opp.tipo_scadenza === 'Taratura',
                        'text-intervento-periodico':
                          opp.tipo_scadenza === 'Periodica',
                      })}
                      style={{ width: 'max-content' }}
                    >
                      {opp.tipo_scadenza}
                    </div>
                  </td>
                  <td>{opp.sede_indirizzo}</td>
                  <td>{opp.num_bilance}</td>
                  <td>
                    {!opp.proposta_exists && (
                      <Button
                        onClick={(e) => {
                          e.stopPropagation()
                          if (openMoreOpportunita === i) {
                            setOpenMoreOpportunita(null)
                          } else {
                            setOpenMoreOpportunita(i)
                          }
                        }}
                        variant="light"
                        className="text-secondary d-flex align-items-center"
                        type="button"
                      >
                        <span className="material-icons">more_horiz</span>
                      </Button>
                    )}
                    {openMoreOpportunita === i && (
                      <div
                        id={`opportunita-${i}`}
                        className="list-group position-absolute"
                        // ref={editDeleteRef}
                        style={{
                          // zIndex: 1,
                          width: 'max-content',
                          boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
                          right: 20,
                          borderRadius: '5px',
                        }}
                      >
                        {!opp.proposta_exists && (
                          <button
                            onClick={() => {
                              activateModalCreaProposta.open(opp)
                            }}
                            className="list-group-item list-group-item-action d-flex align-items-center"
                          >
                            <span
                              className="material-icons me-2"
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              visibility
                            </span>
                            Invia proposta
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </StickyTable>
          <Paginator
            count={opportunita?.count ?? 0}
            currentPage={uiFilters.page}
            goToPage={(page) => setFilters({ page })}
          />
          <div className="position-relative">
            <div
              className="position-absolute d-flex align-items-center list-footer-side"
              style={{
                top: '50%',
                left: 20,
                transform: 'translateY(-50%)',
              }}
            ></div>
          </div>
        </div>
      </div>
      <Modal
        show={stateModalCreaProposta.isOpen}
        onHide={activateModalCreaProposta.close}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Crea Proposta di Intervento</Modal.Title>
        </Modal.Header>
        <ModalBody>
          <Formik
            initialValues={{
              sede: stateModalCreaProposta.value?.sede_pk ?? '',
              tipo_scadenza: stateModalCreaProposta.value?.tipo_scadenza ?? '',
              email_commerciale: stateModalCreaProposta.value?.email_commerciale
                ? stateModalCreaProposta.value?.email_commerciale
                : stateModalCreaProposta.value?.email_referente
                ? stateModalCreaProposta.value?.email_referente
                : '',
              bilance: stateModalCreaProposta.value?.bilance ?? [],
            }}
            validationSchema={Yup.object().shape({
              email_commerciale: Yup.string()
                .email('Invalid email format')
                .required()
                .label('Email commerciale'),
            })} // Add your validation schema h
            onSubmit={async (values) => {
              await fetchApi(
                `${API_URL}/bilance/crea-proposta-da-opportunita/`,
                {
                  method: 'POST',
                  headers: {
                    Authorization: `Bearer ${tokens?.access}`,
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    sede: values.sede,
                    tipo_intervento: values.tipo_scadenza,
                    email_commerciale: values.email_commerciale,
                    bilance: values.bilance,
                  }),
                }
              ).then(() => {
                activateModalCreaProposta.close()
                toast.success('Proposta inviata con successo', {
                  position: 'bottom-right',
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
              })
            }}
          >
            {({ handleSubmit, values, setFieldValue }) => (
              <form onSubmit={handleSubmit}>
                <div className="label-m text-body-secondary">Dati cliente</div>
                <div className="p-md mt-2">
                  <Link
                    className="link-md"
                    to={`/clienti/${stateModalCreaProposta.value?.cliente_pk}`}
                  >
                    {stateModalCreaProposta.value?.cliente}
                  </Link>
                </div>
                <div className="label-m text-body-secondary mt-4">
                  Dati sede
                </div>
                <div className="p-md mt-2">
                  {stateModalCreaProposta.value?.sede_indirizzo}
                </div>
                <div className="label-m text-body-secondary mt-4">
                  Tipo intervento
                </div>
                <div
                  className={classNames('p-md mt-2 badge w-max-content', {
                    'bg-rapporto-taratura-light':
                      stateModalCreaProposta.value?.tipo_scadenza ===
                      'Taratura',
                    'bg-intervento-periodico-light':
                      stateModalCreaProposta.value?.tipo_scadenza ===
                      'Periodica',
                    'text-rapporto-taratura':
                      stateModalCreaProposta.value?.tipo_scadenza ===
                      'Taratura',
                    'text-intervento-periodico':
                      stateModalCreaProposta.value?.tipo_scadenza ===
                      'Periodica',
                  })}
                  style={{ width: 'max-content' }}
                >
                  {stateModalCreaProposta.value?.tipo_scadenza}
                </div>
                <div className="mt-3">
                  <VField
                    name="email_commerciale"
                    label="Email commerciale"
                    required
                  />
                </div>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    type="submit"
                    variant="secondary"
                    className="mt-3 text-white"
                  >
                    Invia Proposta
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </div>
  )
}
